import { ENDPOINT } from 'api/endPoints/getProgressScurveGraph';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const criticalityWeightedSCurve: IHashmapItemComponentProps = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'progressMeasurement', name: 'progressMeasurement', defaultValue: null },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'resourceType', name: 'resourceType', defaultValue: null },
        { key: 'resource', name: 'resource', defaultValue: null },
    ],
    componentKey: 'criticalityWeightedSCurve',
    title: 'Criticality Weighted S-Curve',
    id: 'IntensityCriticalityWeight',
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: MEDIUM,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    endpoint: ENDPOINT,
};
